<template>
  <div>
    <div
      v-if="loader.page || errors.alert"
      class="d-flex justify-content-center"
    >
      <LoaderLogo :loading="loader.page" />
      <Alert
        v-if="errors.alert"
        :title="LABEL.ERRORI.PREFIX"
        :description="LABEL.ERRORI[errors.alert]"
        :btn="{
          label: LABEL.ERRORI.BACK_TO_REQUESTS,
          icon: 'arrow-left',
          action: () =>
            this.$router.push({
              name: nameRoutes.RICHIESTE,
            }),
        }"
      />
    </div>
    <section v-if="!loader.page && !errors.alert">
      <header>
        <h5 class="text-gray-900 font-weight-bold" style="margin-bottom: 25px">
          <font-awesome-icon icon="calendar-day" class="mr-2" />{{
            LABEL.RICHIESTA.PAGE_TITLE(richiesta.data)
          }}
        </h5>
      </header>

      <section class="position-relative">
        <div
          :class="`opacity-${
            lateralCard.open ? '0' : '1'
          } SisrTabletOpacity SisrCenterCard SisrNavigation ${
            lateralCard.open ? 'open' : ''
          }`"
        >
          <div
            :class="`d-flex d-sm-none justify-content-between align-items-center`"
            style="position: relative !important; margin-bottom: 12.5px"
          >
            <h5
              class="text-gray-600 font-weight-bold mb-0"
              style="font-size: 1.17rem"
            >
              <font-awesome-icon icon="utensils" class="mr-2" />

              {{
                N4M.CAPITALIZESTRING(
                  richiesta.pasti[richiesta.currentPastoIndex].descrizionePasto
                )
              }}
            </h5>
          </div>
          <div class="row">
            <!-- NAVIGATION TABLET -->
            <div class="d-none d-sm-block col-4">
              <div
                id="v-pills-tab"
                class="nav flex-column nav-pills"
                role="tablist"
              >
                <a
                  data-toggle="tab"
                  role="tab"
                  v-for="(pasto, index) in richiesta.pasti"
                  :key="pasto.idPasto"
                  :id="`${setPortataTabAttribute(pasto)}Tab`"
                  :class="`nav-link border-0 notUnderline ${
                    index === richiesta.currentPastoIndex ? 'active' : ''
                  }`"
                  :href="`#${setPortataTabAttribute(pasto)}`"
                  :aria-controls="`${setPortataTabAttribute(pasto)}`"
                  :aria-selected="`${index == richiesta.currentPastoIndex}`"
                  @click="setLateralCardOpen(index)"
                >
                  <span>{{ pasto.descrizionePasto }}</span>
                </a>
              </div>
            </div>
            <div class="col-xs-12 col-sm-8" id="view">
              <div class="tab-content" id="nav-tabContent">
                <article
                  :class="`SisrCard br-10 container-card shadow-sm tab-pane fade ${
                    index === richiesta.currentPastoIndex ? 'show active' : ''
                  }`"
                  v-for="(pasto, index) in richiesta.pasti"
                  :key="pasto.idPortata"
                  :id="setPortataTabAttribute(pasto)"
                  :aria-labelledby="`${setPortataTabAttribute(pasto)}Tab`"
                  role="tabpanel"
                >
                  <header class="text-gray-800">
                    <h6 class="font-weight-bold d-flex">
                      <font-awesome-icon icon="notes-medical" class="mr-2" />{{
                        pasto.regimeAlimentarePortata
                      }}
                    </h6>

                    <h6
                      :class="`d-flex SisrSubTitleLabel ${pasto.subTitle.class}`"
                    >
                      <font-awesome-icon
                        :icon="pasto.subTitle.icon"
                        class="mr-2"
                      />
                      <span>
                        {{ pasto.subTitle.text }}
                      </span>
                    </h6>
                  </header>

                  <!-- Se il pasto non è modificabile non passo itemButton per non avere nella lista la possbilità di navigare verso la modifca della -->
                  <List :items="pasto.portate" :itemButton="button" />

                  <!-- Se si è nella modalità tablet verrà 
                  visualizzato il btn "richieste" su cellulare il btn "scegli pasto" -->
                  <button
                    class="d-block d-sm-none btn btn-secondary d-block m-auto"
                    @click="setLateralCardOpen()"
                  >
                    <span>
                      <font-awesome-icon icon="arrow-left" class="mr-2" />
                      {{ LABEL.RICHIESTA.MEAL_CHOISE }}
                    </span>
                  </button>
                  <button
                    class="d-none d-sm-block btn btn-secondary m-auto"
                    @click="backToRichieste"
                  >
                    <span>
                      <font-awesome-icon icon="arrow-left" class="mr-2" />
                      {{ LABEL.RICHIESTA.REQUESTS }}
                    </span>
                  </button>
                </article>
              </div>
            </div>
          </div>
        </div>

        <!-- NAVIGATION PHONE -->
        <div
          id="phoneNavigation"
          :class="`SisrLateralCard rightLateralCard opacity-${
            lateralCard.open ? '1 open' : '0'
          } d-sm-none`"
        >
          <article
            :class="`d-block d-sm-none SisrCard shadow-sm br-10 container-card`"
          >
            <header class="text-gray-800">
              <h6 class="font-weight-bold">
                <font-awesome-icon icon="utensils" class="mr-2" />{{
                  LABEL.RICHIESTA.MEAL_CHOISE_TITLE
                }}
              </h6>
            </header>

            <ul
              id="phoneNavigation"
              class="nav nav-tabs d-block"
              style="margin-bottom: 1rem; border: none"
              role="tablist"
            >
              <li
                class="
                  nav-item
                  d-flex
                  justify-content-between
                  align-items-center
                  SisrCardOption
                "
                v-for="(pasto, index) in richiesta.pasti"
                :key="pasto.idPortata"
              >
                <span class="d-block SisrLabel">
                  {{ pasto.descrizionePasto }}
                </span>
                <button
                  :id="`${setPortataTabAttribute(pasto)}Tab`"
                  class="nav-link btn btn-primary"
                  :href="`#${setPortataTabAttribute(pasto)}`"
                  :aria-controls="`${setPortataTabAttribute(pasto)}`"
                  :aria-selected="`${index == richiesta.currentPastoIndex}`"
                  data-toggle="tab"
                  role="tab"
                  @click="setLateralCardOpen(index)"
                >
                  <span
                    ><font-awesome-icon icon="eye" class="mr-2" />{{
                      LABEL.RICHIESTA.VIEW_MEAL
                    }}</span
                  >
                </button>
              </li>
            </ul>
            <button
              class="btn btn-secondary d-block m-auto"
              @click="backToRichieste"
            >
              <span>
                <font-awesome-icon icon="arrow-left" class="mr-2" />
                {{ LABEL.RICHIESTA.REQUESTS }}
              </span>
            </button>
          </article>
        </div>
      </section>
    </section>
  </div>
</template>

<script>
import { richiestaMixin } from "../../libs/mixins/application";
export default {
  mixins: [richiestaMixin],
};
</script>
